import { render } from "./shifts.vue?vue&type=template&id=4c1a9a9d&scoped=true"
import script from "./shifts.vue?vue&type=script&lang=js"
export * from "./shifts.vue?vue&type=script&lang=js"

import "./shifts.vue?vue&type=style&index=0&id=4c1a9a9d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c1a9a9d"]])

export default __exports__